// import React, { useEffect, useState } from 'react'
// import Header from '../../layouts/Header';
// import { Button, Card, Col, Container, Form, Image, Modal, Row, Spinner, Tab, Table, Tabs } from 'react-bootstrap';
// import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';
// import Select from "react-select";
// import DatePicker from 'react-datepicker';
// import makeAnimated from "react-select/animated";
// import { useSelector } from 'react-redux';

// const AdvertisementMgt = () => {

//     const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
//     const [skin, setSkin] = useState(currentSkin);
//     const { access } = useSelector((state) => state.login);
//     const { loginEmail } = useSelector((state) => state.login);
//     const email = loginEmail || localStorage.getItem("email");
//     const [addAccess, setAddAccess] = useState([]);
    
//     console.log("Access :", access);
    
//     useEffect(() => {
//         if (Array.isArray(access)) {
//             const filteredAccess = access?.filter((perm) =>
//                 perm?.startsWith("AdvertisementMgt:")
//             );
//             setAddAccess(filteredAccess);
//         } 
//     }, [access]);
    
//     console.log("Menu Access:", addAccess);

//     const accessToken = localStorage.getItem("authToken");
//     const [inputData, setInputData] = useState({
//         title: "",
//         type: "",
//         sequenceNo: "",
//         product: "",
//         isTopImage: "",
//         isBottomImage: "",
//         link: ""
//     });
//     const [listLoading, setListLoading] = useState(false);
//     const [topImageAdd, setTopImageAdd] = useState([]);
//     const [bottomImageAdd, setBottomImageAdd] = useState({});
//     const [activeTab, setActiveTab] = useState("CLICKABLE");
//     const [clickableAdvertisementData, setClickableAdvertisementData] = useState([]);
//     const [nonClickableAdvertisementData, setNonClickableAdvertisementData] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const animatedComponents = makeAnimated();
//     const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
//     const [outlets, setOutlets] = useState([]);
//     const [openEditModal, setOpenEditModal] = useState(false);
//     const [editedData, setEditedData] = useState({});
//     const [productsList, setProductsList] = useState([]);
//     const [toDate, setToDate] = useState(null);
//     const [fromDate, setFromDate] = useState(null);
//     const [openViewModal, setOpenViewModal] = useState(false);
//     const [singleAdData, setSingleAdData] = useState("");
//     const [openDeleteModal, setOpenDeleteModal] = useState(false);
//     const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
//     const [adId, setAdId] = useState('');
//     const [openAddModal, setOpenAddModal] = useState(false);
//     const [image, setImage] = useState(null);
//     const [isOpenUpdateImageModal, setIsOpenUpdateImageModal] = useState(false);
//     const [isImageUpdating, setIsImageUpdating] = useState(false);
//     const [isRefreshBtnLoading, setIsRefreshBtnLoading] = useState(false);

//     const outletData = outlets?.map((outlet) => ({
//         value: outlet._id,
//         label: `${outlet.name} (${outlet.city})`,
//     }));

//     const customStyles = {
//         control: (provided, state) => ({
//             ...provided,
//             width: "100%",
//             borderRadius: "6px",
//             minWidth: "200px",
//             borderColor: state.isFocused ? "#80bdff" : "#ced4da",
//             boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
//             "&:hover": {
//                 borderColor: state.isFocused ? "#80bdff" : "#ced4da",
//             },
//         }),
//         placeholder: (provided) => ({
//             ...provided,
//             color: "#6c757d",
//         }),
//     };

//     const handleTabChange = (tab) => {
//         setActiveTab(tab);
//     };

//     const getAdvertisementList = async () => {
//         setListLoading(true);
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//             };
//             const response = await axiosInstance.get("advertisement", { headers });

//             if (response?.data?.status === true) {
//                 const totalNonClickableAdvertisements=response?.data?.data?.advertisements.nonClickableAdvertisements;
//                 console.log("Total Non Clickable Add :", totalNonClickableAdvertisements);
                
//                 const nonClickableAdvertisements=totalNonClickableAdvertisements.filter(ad=>ad.isTopImage===false && ad.isBottomImage===false);
//                 const topImageAdvertisement=totalNonClickableAdvertisements.filter(ad=>ad.isTopImage===true);
//                 const bottomImageAdvertisement=totalNonClickableAdvertisements.find(ad=>ad.isBottomImage===true);
//                 setClickableAdvertisementData(
//                     response?.data?.data?.advertisements.clickableAdvertisements
//                 );
//                 console.log("Top Images :", topImageAdvertisement);
                
//                 setNonClickableAdvertisementData(nonClickableAdvertisements);
//                 setTopImageAdd(topImageAdvertisement);
//                 setBottomImageAdd(bottomImageAdvertisement);
                
//             }
//         } catch (error) {
//             if (error.response && error.response?.data?.status === false) {
//                 let errorMessage = error.response.data.error;
//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         } finally {
//             setListLoading(false);
//         }
//     };

//     const getOutlets = async () => {
//         try {
//           const headers = {
//             Authorization: `Bearer ${accessToken}`,
//           };
//           const response = await axiosInstance.get("outlet", { headers });
    
//           if (response?.data?.status === true) {
            
//             let filteredOutlets = response?.data?.data?.outlets?.filter((act) => act?.status === "ACTIVE");
            
//             setOutlets(filteredOutlets);
//           }
//         } catch (error) {
//           if (error.response && error.response?.data?.status === false) {
//             let errorMessage = error.response.data.error;
//             toast.error(errorMessage, {
//               position: "top-right",
//               autoClose: 3000,
//               theme: "colored",
//             });
//           }
//         }
//     };

//     const getProductsList = async () => {
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//             };
//             const response = await axiosInstance.get("product", { headers });
//             if (response?.data?.status === true) {
//                 setProductsList(response?.data?.data?.products);
//             }
//         } catch (error) {
//             if (error.response && error.response?.data?.status === false) {
//                 let errorMessage = error.response.data.error;
//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         }
//     };

//     const handleOpenViewModal = (id) => {
//         setOpenViewModal(true);
//         getSingleAdvertisement(id);
//     };

//     const getSingleAdvertisement = async (id) => {
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//             };
//             const response = await axiosInstance.get(`advertisement?_id=${id}`, { headers });

//             if (response?.data?.status === true) {
//                 setSingleAdData(response?.data?.data?.advertisements);
//             }
//         } catch (error) {
//             if (error.response && error.response?.data?.status === false) {
//                 let errorMessage = error.response.data.error;
//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         }
//     };

//     const handleOpenAddModal = () => {
//         setOpenAddModal(true);
//     }

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setInputData((prev) => ({ ...prev, [name]: value }));
//     }

//     const handleImageChange = () => {
//         const input = document.getElementById("imageInput");
//         const file = input.files[0];
    
//         if (file) {
//           const reader = new FileReader();
    
//           // reader.onloadend = () => {
//           //   const image = new Image();
//           //   image.src = reader.result;
    
//           //   image.onload = () => {
//           //     const width = image.width;
//           //     const height = image.height;
    
//           //     const aspectRatio = width / height;
//           //     const targetAspectRatio = 16 / 9;
    
//           //     if (Math.abs(aspectRatio - targetAspectRatio) < 0.01) {
//           //       alert("Image dimensions are valid!");
//           //       setImage(file);
//           //     } else {
//           //       alert(
//           //         "Image dimensions are not valid. Please choose an image with a 16:9 aspect ratio."
//           //       );
//           //       input.value = "";
//           //     }
//           //   };
//           // };
    
//           setImage(file);
    
//           reader.readAsDataURL(file);
//         }
//     };

//     const handleSelectChange = (selected) => {
//         setSelectedExcludedOutlets(selected);
//     }

//     const addAdvertisement = async (e) => {
//         e.preventDefault();
//         setIsLoading(true)
//         try {
//             // Format the dates
//             const updatedStartDate = fromDate
//                 ? new Date(fromDate.getTime() - fromDate.getTimezoneOffset() * 60000)
//                         .toISOString()
//                         .split("T")[0]
//                 : null;
        
//             const updatedEndDate = toDate
//                 ? new Date(toDate.getTime() - toDate.getTimezoneOffset() * 60000)
//                         .toISOString()
//                         .split("T")[0]
//                 : null;
    
    
//             console.log("updatedStartDate :", updatedStartDate);
//             console.log("updatedEndDate :", updatedEndDate);
        
//             let selectOutlets = selectedExcludedOutlets.map((val) => val?.value);
//             console.log("Selected Outlets :", selectOutlets);
            
//             let newInputData = {
//                 ...inputData,
//                 excludedOutlets: selectOutlets
//             }
    
//             const formData = new FormData();
//             formData.append("title", newInputData.title);
//             formData.append("type", newInputData.type);
//             formData.append("sequenceNo", newInputData.sequenceNo);
//             if(updatedStartDate !== null){
//                 formData.append("validityStartDate", updatedStartDate);
//             }
//             if(updatedEndDate !== null){
//                 formData.append("validityEndDate", updatedEndDate);
//             }
//             if (newInputData?.product !== "") {
//                 formData.append("product", newInputData.product);
//             }
//             if (newInputData?.isTopImage !== "") {
//                 formData.append("isTopImage", newInputData.isTopImage);
//             }
//             if (newInputData?.isBottomImage !== "") {
//                 formData.append("isBottomImage", newInputData.isBottomImage);
//             }
//             if (newInputData?.link !== "") {
//                 formData.append("link", newInputData.link);
//             }
//             formData.append("adImage", image);
        
//             // Append each excluded outlet as excludedOutlets[0], excludedOutlets[1], etc.
//             if (selectOutlets?.length > 0) {
//                 selectOutlets.forEach((outlet, index) => {
//                 formData.append(`excludedOutlets[${index}]`, outlet);
//                 });
//             }
        
//             const headers = {
//                 "Content-Type": "multipart/form-data",
//                 Authorization: `Bearer ${accessToken}`,
//             };
        
//             const response = await axiosInstance.post("advertisement", formData, {
//                 headers,
//             });
        
//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "light",
//                 });
//                 e.target.reset();
//                 setInputData({
//                     title: '',
//                     type: '',
//                     sequenceNo: '',
//                     product: '',
//                     link: '',
//                     isTopImage: '',
//                     isBottomImage: ''
//                 })
//                 setFromDate(null);
//                 setToDate(null);
//                 getAdvertisementList();
//                 setOpenAddModal(false);
//                 setSelectedExcludedOutlets([]);
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let errorMessage = '';
//                 if ( error.response?.status === 406 ) {
//                     errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
//                 }
//                 else if ( error.response?.status === 412 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 } else if (error.response?.status === 500) {
//                     errorMessage = error?.response?.data?.error
//                 }
        
//                 toast.error(errorMessage, {
//                 position: "top-right",
//                 autoClose: 3000,
//                 theme: "light",
//                 });
//             }
//         } finally {
//           setIsLoading(false);
//         }
//     }

//     const handleCloseAddModal = () => {
//         setOpenAddModal(false);
//         setInputData({
//             title: "",
//             type: "",
//             sequenceNo: "",
//             product: "",
//             isTopImage: "",
//             isBottomImage: "",
//             link: ""
//         })
//     }

//     const handleOpenEditModal = (data) => {
//         console.log("Edited Data :", data);
        
//         setOpenEditModal(true);
//         setEditedData({
//             _id: data?._id,
//             title: data?.title,
//             type: data?.type,
//             sequenceNo: data?.sequenceNo,
//             product: data?.product?._id,
//             isTopImage: data?.isTopImage,
//             isBottomImage: data?.isBottomImage,
//             link: data?.link
//         })
//         // Convert ISO string to Date object
//         setFromDate(data?.validityStartDate ? new Date(data.validityStartDate) : null);
//         setToDate(
//             data?.validityEndDate
//               ? new Date(new Date(data.validityEndDate).setDate(new Date(data.validityEndDate).getDate() - 1))
//               : null
//         );
        
//         let selectedExOutlet = data?.excludedOutlets;
//         let mappedSelectedExOutlet = selectedExOutlet?.map((m) =>
//         ({
//             value: m?._id,
//             label: m?.name
//         }))
//         setSelectedExcludedOutlets(mappedSelectedExOutlet);
//     };

//     const handleEditSelectChange = (selected) => {
//         setSelectedExcludedOutlets(selected);
//     };

//     const handleEditChange = (e) => {
//         const { name, value } = e.target;
//         setEditedData((prev) => ({ ...prev, [name]: value }))
//     };

//     const handleFromDateChange = (date) => {
//         setFromDate(date);
//     };
    
//     const handleToDateChange = (date) => {        
//         setToDate(date);
//     };

//     const handleEditSubmit = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
        
//         try {
//             // Check if only one of the dates is selected
//             if ((fromDate && !toDate) || (!fromDate && toDate)) {
//                 toast.error("Please select both start date and end date", {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//                 setIsLoading(false);
//                 return;
//             }
//             // Format the dates
//             const updatedStartDate = fromDate
//                 ? new Date(fromDate.getTime() - fromDate.getTimezoneOffset() * 60000)
//                         .toISOString()
//                         .split("T")[0]
//                 : null;

//             const updatedEndDate = toDate
//                 ? new Date(toDate.getTime() - toDate.getTimezoneOffset() * 60000)
//                         .toISOString()
//                         .split("T")[0]
//                 : null;

//             let selectedExOutlets = selectedExcludedOutlets?.map((ex) => ex?.value);
//             let newEditedData = {
//                 ...editedData,
//                 excludedOutlets: selectedExOutlets
//             }

//             const formData = new FormData();
//             formData.append("_id", newEditedData?._id)
//             formData.append("title", newEditedData.title);
//             formData.append("type", newEditedData.type);
//             formData.append("sequenceNo", newEditedData.sequenceNo);
//             formData.append("validityStartDate", updatedStartDate);
//             formData.append("validityEndDate", updatedEndDate);
//             if (newEditedData?.product !== "" && newEditedData?.product !== undefined && newEditedData?.product !== null) {                
//                 formData.append("product", newEditedData?.product);
//             }
//             if (newEditedData?.isTopImage !== ""){
//                 formData.append("isTopImage", newEditedData?.isTopImage);
//             }
//             if (newEditedData?.link !== ""){
//                 formData.append("link", newEditedData?.link);
//             }
//             if (newEditedData?.isBottomImage !== ""){
//                 formData.append("isBottomImage", newEditedData?.isBottomImage);
//             }

//             // Check if excluded outlets are empty
//             if (selectedExOutlets?.length === 0 || selectedExOutlets === undefined) {
//                 formData.append("excludedOutlets", null);
//             } else {
//                 selectedExOutlets.forEach((outlet, index) => {
//                 formData.append(`excludedOutlets[${index}]`, outlet);
//                 });
//             }

//             const headers = {
//                 "Content-Type": "multipart/form-data",
//                 Authorization: `Bearer ${accessToken}`,
//             };

//             const response = await axiosInstance.put("advertisement", formData, {
//                 headers,
//             });

//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//                 setOpenEditModal(false);
//                 getAdvertisementList();
                
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let errorMessage = '';
//                 if ( error.response?.status === 406 ) {
//                     errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
//                 }
//                 else if ( error.response?.status === 404 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 }
//                 else if ( error.response?.status === 412 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 } else if (error.response?.status === 500) {
//                     errorMessage = error?.response?.data?.error
//                 }

//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleOpenDeleteModal = (id) => {
//         setOpenDeleteModal(true);
//         setAdId(id);
//     };

//     const deleteAdvertisement = async (e) => {
//         e.preventDefault();
//         setIsDeleteBtnLoading(true);
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//             };

//             const data = {
//                 _id: adId,
//             };
//             const response = await axiosInstance.delete(`advertisement`, { data, headers });
//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//                 getAdvertisementList();
//                 setOpenDeleteModal(false);
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let errorMessage = '';
//                 if (
//                     error.response?.status === 406
//                 ) {
//                     errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
//                 }
//                 else if (
//                     error.response?.status === 412
//                 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 } else if (error.response?.status === 500) {
//                     errorMessage = error?.response?.data?.error
//                 }

//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         } finally {
//             setIsDeleteBtnLoading(false);
//         }
//     };

//     const openUpdateImageModal = (data) => {
//         setEditedData((prev) => ({
//             ...prev,
//             _id: data?._id
//         }))
//         setIsOpenUpdateImageModal(true)
//     }

//     const handleEditImageChange = (e) => {
//         const input = document.getElementById("imageInput");
//         const file = input.files[0];

//         if (file) {
//             const reader = new FileReader();

//             // <--------------- This is Validation For Updating Image --------------> 
//             // reader.onloadend = () => {
//             //     const image = new Image();
//             //     image.src = reader.result;

//             //     image.onload = () => {
//             //         const width = image.width;
//             //         const height = image.height;

//             //         const aspectRatio = width / height;
//             //         const targetAspectRatio = 16 / 9;

//             //         if (Math.abs(aspectRatio - targetAspectRatio) < 0.01) {
//             //             alert("Image dimensions are valid!");
//             //             setImage(file);
//             //         } else {
//             //             alert(
//             //                 "Image dimensions are not valid. Please choose an image with a 16:9 aspect ratio."
//             //             );
//             //             input.value = "";
//             //         }
//             //     };
//             // };

//             setImage(file);

//             reader.readAsDataURL(file);
//         }
//     };

//     const handleEditImage = async () => {
//         // e.preventDefault()
//         console.log("HEloo");
        
//         setIsImageUpdating(true);

//         try {
//             const formData = new FormData();
//             formData.append("_id", editedData?._id)
//             formData.append("adImage", image);

//             const headers = {
//                 "Content-Type": "multipart/form-data",
//                 Authorization: `Bearer ${accessToken}`,
//             };

//             const response = await axiosInstance.put(`advertisement`, formData, {
//                 headers,
//             });

//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.data?.message, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//                 // e.target.reset()
//                 setIsOpenUpdateImageModal(false)
//                 getAdvertisementList()
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let errorMessage = '';
//                 if (
//                     error.response?.status === 406
//                 ) {
//                     errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
//                 }
//                 else if (
//                     error.response?.status === 412
//                 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 } else if (error.response?.status === 500) {
//                     errorMessage = error?.response?.data?.error
//                 }

//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         } finally {
//             setIsImageUpdating(false)
//         }
//     };

//     const handleRefresh = async() => {
//         setIsRefreshBtnLoading(true);
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`
//             }
//             const response = await axiosInstance.get('advertisement/clear-advertisement-cache', { headers });
            
//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.message, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         } catch (error) {
//             if (error?.response) {
//                 let errorMessage = '';
//                 if ( error.response?.status === 406 ) {
//                     errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
//                 }
//                 else if ( error.response?.status === 404 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 }
//                 else if ( error.response?.status === 412 ) {
//                     errorMessage = error?.response?.data?.data?.message;
//                 } else if (error.response?.status === 500) {
//                     errorMessage = error?.response?.data?.error
//                 }

//                 toast.error(errorMessage, {
//                     position: "top-right",
//                     autoClose: 3000,
//                     theme: "colored",
//                 });
//             }
//         } finally {
//             setIsRefreshBtnLoading(false);
//         }
//     };

//     useEffect(() => {
//         getAdvertisementList();
//         getOutlets();
//         getProductsList();
//     }, [])

//     return (
//         <React.Fragment>
//             <Header onSkin={setSkin} />
//             <div className="main main-app p-3 p-lg-4">
//                 <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
//                     <Row className="pt-4">
//                         <Col>
//                             <h5 className="fw-semibold">ADVERTISEMENT MANAGEMENT</h5>
//                         </Col>
//                     </Row>

//                     <Row className='justify-content-between' style={{ backgroundColor: "whitesmoke" }}>
//                         <Col lg="3" className="d-flex justify-content-end flex-column  mt-4">
//                             <Button
//                               variant="success"
//                               className="fw-semibold"
//                               onClick={handleRefresh}
//                             >
//                                 {isRefreshBtnLoading ? <Spinner size='sm' /> : (
//                                     <>
//                                         <i className="ri-refresh-line" style={{ marginRight: "5px" }}></i>
//                                         Clear or Refresh Cache
//                                     </>
//                                 ) }
                                
//                             </Button>
//                         </Col>
//                         {(addAccess?.includes("AdvertisementMgt:add") || email === "contact@xpansecafe.com") && (
//                             <Col lg="3" className="d-flex justify-content-end flex-column  mt-4">
//                                 <Button
//                                 variant="primary"
//                                 className="fw-semibold"
//                                 onClick={handleOpenAddModal}
//                                 >
//                                     <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
//                                     Add New Advertisement
//                                 </Button>
//                             </Col>
//                         )}
//                     </Row>

//                     <Row style={{ backgroundColor: "whitesmoke" }}>
//                         {/* <Col> */}
//                             <Container className="my-4">
//                                 <Tabs
//                                     activeKey={activeTab}
//                                     onSelect={handleTabChange}
//                                     className="mb-4"
//                                     style={{
//                                         backgroundColor: '#f8f9fa',
//                                         borderRadius: '8px',
//                                         padding: '10px',
//                                         // boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//                                     }}
//                                 >
//                                     <Tab
//                                         eventKey="CLICKABLE"
//                                         title="CLICKABLE"
//                                         style={{ fontSize: '16px', fontWeight: '500', color: '#495057' }}
//                                     >
//                                         <Row className="mt-3 g-3">
//                                             {listLoading ? (
//                                                 // Skeleton Loading for Clickable Ads
//                                                 Array.from({ length: 4 }).map((_, index) => (
//                                                     <Col key={`skeleton-clickable-${index}`} lg={3} md={4}>
//                                                         <Card
//                                                             className="h-100 skeleton-card"
//                                                             style={{
//                                                                 border: '1px solid #e9ecef',
//                                                                 borderRadius: '10px',
//                                                             }}
//                                                         >
//                                                             <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                 {/* Skeleton for Image */}
//                                                                 <div
//                                                                     style={{
//                                                                         width: '100%',
//                                                                         height: '200px',
//                                                                         borderRadius: '8px',
//                                                                         background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                         backgroundSize: '200% 100%',
//                                                                         animation: 'skeletonPulse 1.5s infinite',
//                                                                         marginBottom: '15px'
//                                                                     }}
//                                                                 />
//                                                                 {/* Skeleton for Title */}
//                                                                 <div
//                                                                     style={{
//                                                                         width: '80%',
//                                                                         height: '20px',
//                                                                         background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                         backgroundSize: '200% 100%',
//                                                                         animation: 'skeletonPulse 1.5s infinite',
//                                                                         borderRadius: '4px',
//                                                                         margin: '0 auto'
//                                                                     }}
//                                                                 />
//                                                             </Card.Body>
//                                                             {/* Skeleton for Action Buttons */}
//                                                             <div
//                                                                 className="d-flex justify-content-around p-2"
//                                                                 style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                             >
//                                                                 {[1, 2, 3].map((btnIndex) => (
//                                                                     <div
//                                                                         key={btnIndex}
//                                                                         style={{
//                                                                             width: '60px',
//                                                                             height: '32px',
//                                                                             background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                             backgroundSize: '200% 100%',
//                                                                             animation: 'skeletonPulse 1.5s infinite',
//                                                                             borderRadius: '4px',
//                                                                         }}
//                                                                     />
//                                                                 ))}
//                                                             </div>
//                                                         </Card>
//                                                     </Col>
//                                                 ))
//                                             ) : clickableAdvertisementData?.length === 0 ? (
//                                                 // Empty State
//                                                 <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px', width: '100%' }}>
//                                                     <div className="text-center">
//                                                         <div className="text-muted mb-2">
//                                                             <i className="bi bi-megaphone" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
//                                                         </div>
//                                                         <p className="text-muted">No clickable advertisements found</p>
//                                                     </div>
//                                                 </div>
//                                             ) : (
//                                                 // Actual Clickable Ads
//                                                 clickableAdvertisementData.map((ad) => (
//                                                     <Col key={ad.id} lg={3} md={4}>
//                                                         <Card
//                                                             className="h-100"
//                                                             style={{
//                                                                 border: '1px solid #e9ecef',
//                                                                 borderRadius: '10px',
//                                                                 transition: 'transform 0.2s, box-shadow 0.2s',
//                                                                 cursor: 'pointer',
//                                                             }}
//                                                             onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
//                                                             onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//                                                         >
//                                                             <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                 <Image
//                                                                     src={ad.adImagePath}
//                                                                     onClick={() => openUpdateImageModal(ad)}
//                                                                     alt="ad-pic"
//                                                                     fluid
//                                                                     style={{
//                                                                         borderRadius: '8px',
//                                                                         maxHeight: '200px',
//                                                                         objectFit: 'cover',
//                                                                     }}
//                                                                 />
//                                                                 <h5
//                                                                     className="mt-3"
//                                                                     style={{ color: '#0d6efd', fontWeight: '600', fontSize: '18px' }}
//                                                                 >
//                                                                     {ad.title.toUpperCase()}
//                                                                 </h5>
//                                                             </Card.Body>
//                                                             <div
//                                                                 className="d-flex justify-content-around p-2"
//                                                                 style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                             >
//                                                                 {(addAccess?.includes("AdvertisementMgt:get") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         variant="light"
//                                                                         title="View"
//                                                                         className='text-success'
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                         onClick={() => handleOpenViewModal(ad._id)}
//                                                                     >
//                                                                         <i className="bi bi-eye" style={{ fontSize: '15px' }}></i> View
//                                                                     </Button>
//                                                                 )}
//                                                                 {(addAccess?.includes("AdvertisementMgt:udpate") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         className='text-primary'
//                                                                         variant="light"
//                                                                         title="Edit"
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                         onClick={() => handleOpenEditModal(ad)}
//                                                                     >
//                                                                         <i className="bi bi-pencil" style={{ fontSize: '15px' }}></i> Edit
//                                                                     </Button>
//                                                                 )}
//                                                                 {(addAccess?.includes("AdvertisementMgt:delete") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         className='text-danger'
//                                                                         variant="light"
//                                                                         title="Delete"
//                                                                         onClick={() => handleOpenDeleteModal(ad._id)}
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
                                                                        
//                                                                     >
//                                                                         <i className="bi bi-trash" style={{ fontSize: '15px' }}></i> Delete
//                                                                     </Button>
//                                                                 )}
//                                                             </div>
//                                                         </Card>
//                                                     </Col>
//                                                 ))
//                                             )}
//                                         </Row>
//                                     </Tab>

//                                     <Tab
//                                         eventKey="NON CLICKABLE"
//                                         title="NON CLICKABLE"
//                                         style={{ fontSize: '16px', fontWeight: '500', color: '#495057' }}
//                                     >
//                                         <Row className="mt-3 g-3">
//                                             {listLoading ? (
//                                                 // Skeleton Loading for Non-Clickable Ads
//                                                 Array.from({ length: 4 }).map((_, index) => (
//                                                     <Col key={`skeleton-nonclickable-${index}`} lg={3} md={4}>
//                                                         <Card
//                                                             className="h-100 skeleton-card"
//                                                             style={{
//                                                                 border: '1px solid #e9ecef',
//                                                                 borderRadius: '10px',
//                                                             }}
//                                                         >
//                                                             <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                 {/* Skeleton for Image */}
//                                                                 <div
//                                                                     style={{
//                                                                         width: '100%',
//                                                                         height: '200px',
//                                                                         borderRadius: '8px',
//                                                                         background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                         backgroundSize: '200% 100%',
//                                                                         animation: 'skeletonPulse 1.5s infinite',
//                                                                         marginBottom: '15px'
//                                                                     }}
//                                                                 />
//                                                                 {/* Skeleton for Title */}
//                                                                 <div
//                                                                     style={{
//                                                                         width: '80%',
//                                                                         height: '20px',
//                                                                         background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                         backgroundSize: '200% 100%',
//                                                                         animation: 'skeletonPulse 1.5s infinite',
//                                                                         borderRadius: '4px',
//                                                                         margin: '0 auto'
//                                                                     }}
//                                                                 />
//                                                             </Card.Body>
//                                                             {/* Skeleton for Action Buttons */}
//                                                             <div
//                                                                 className="d-flex justify-content-around p-2"
//                                                                 style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                             >
//                                                                 {[1, 2, 3].map((btnIndex) => (
//                                                                     <div
//                                                                         key={btnIndex}
//                                                                         style={{
//                                                                             width: '60px',
//                                                                             height: '32px',
//                                                                             background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                             backgroundSize: '200% 100%',
//                                                                             animation: 'skeletonPulse 1.5s infinite',
//                                                                             borderRadius: '4px',
//                                                                         }}
//                                                                     />
//                                                                 ))}
//                                                             </div>
//                                                         </Card>
//                                                     </Col>
//                                                 ))
//                                             ) : nonClickableAdvertisementData.length === 0 ? (
//                                                 // Empty State
//                                                 <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px', width: '100%' }}>
//                                                     <div className="text-center">
//                                                         <div className="text-muted mb-2">
//                                                             <i className="bi bi-image" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
//                                                         </div>
//                                                         <p className="text-muted">No non-clickable advertisements found</p>
//                                                     </div>
//                                                 </div>
//                                             ) : (
//                                                 // Actual Non-Clickable Ads
//                                                 nonClickableAdvertisementData.map((ad) => (
//                                                     <Col key={ad.id} lg={3} md={4}>
//                                                         <Card
//                                                             className="h-100"
//                                                             style={{
//                                                                 border: '1px solid #e9ecef',
//                                                                 borderRadius: '10px',
//                                                                 transition: 'transform 0.2s, box-shadow 0.2s',
//                                                                 cursor: 'pointer',
//                                                             }}
//                                                             onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
//                                                             onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//                                                         >
//                                                             <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                 <Image
//                                                                     src={ad.adImagePath}
//                                                                     onClick={() => openUpdateImageModal(ad)}
//                                                                     alt="ad-pic"
//                                                                     fluid
//                                                                     style={{
//                                                                         borderRadius: '8px',
//                                                                         maxHeight: '200px',
//                                                                         objectFit: 'cover',
//                                                                     }}
//                                                                 />
//                                                                 <h5
//                                                                     className="mt-3"
//                                                                     style={{ color: '#0d6efd', fontWeight: '600', fontSize: '18px' }}
//                                                                 >
//                                                                     {ad.title.toUpperCase()}
//                                                                 </h5>
//                                                             </Card.Body>
//                                                             <div
//                                                                 className="d-flex justify-content-around p-2"
//                                                                 style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                             >
//                                                                 {(addAccess?.includes("AdvertisementMgt:get") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         variant="light"
//                                                                         title="View"
//                                                                         size='sm'
//                                                                         className='text-success'
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                         onClick={() => handleOpenViewModal(ad._id)}
//                                                                     >
//                                                                         <i className="bi bi-eye" style={{ fontSize: '15px' }}></i> View
//                                                                     </Button>
//                                                                 )}
//                                                                 {(addAccess?.includes("AdvertisementMgt:update") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         variant="light"
//                                                                         title="Edit"
//                                                                         size='sm'
//                                                                         className='text-primary'
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                         onClick={() => handleOpenEditModal(ad)}
//                                                                     >
//                                                                         <i className="bi bi-pencil" style={{ fontSize: '15px' }}></i> Edit
//                                                                     </Button>
//                                                                 )}
//                                                                 {(addAccess?.includes("AdvertisementMgt:delete") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         variant="light"
//                                                                         title="Delete"
//                                                                         size='sm'
//                                                                         className='text-danger'
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                         onClick={() => handleOpenDeleteModal(ad._id)}
//                                                                     >
//                                                                         <i className="bi bi-trash" style={{ fontSize: '15px' }}></i> Delete
//                                                                     </Button>
//                                                                 )}
//                                                             </div>
//                                                         </Card>
//                                                     </Col>
//                                                 ))
//                                             )}
//                                         </Row>
//                                     </Tab>

//                                     <Tab
//                                         eventKey="TOP & BOTTOM IMAGES"
//                                         title="TOP & BOTTOM IMAGES"
//                                         style={{ fontSize: '16px', fontWeight: '500', color: '#495057' }}
//                                     >
//                                         <Row className="mt-3 g-3">
//                                             {listLoading ? (
//                                                 // Skeleton Loading for Top & Bottom Images
//                                                 Array.from({ length: 4 }).map((_, index) => (
//                                                     <Col key={`skeleton-topbottom-${index}`} lg={3} md={4}>
//                                                         <Card
//                                                             className="h-100 skeleton-card"
//                                                             style={{
//                                                                 border: '1px solid #e9ecef',
//                                                                 borderRadius: '10px',
//                                                             }}
//                                                         >
//                                                             <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                 {/* Skeleton for Image */}
//                                                                 <div
//                                                                     style={{
//                                                                         width: '100%',
//                                                                         height: '200px',
//                                                                         borderRadius: '8px',
//                                                                         background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                         backgroundSize: '200% 100%',
//                                                                         animation: 'skeletonPulse 1.5s infinite',
//                                                                         marginBottom: '15px'
//                                                                     }}
//                                                                 />
//                                                                 {/* Skeleton for Title */}
//                                                                 <div
//                                                                     style={{
//                                                                         width: '80%',
//                                                                         height: '20px',
//                                                                         background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                         backgroundSize: '200% 100%',
//                                                                         animation: 'skeletonPulse 1.5s infinite',
//                                                                         borderRadius: '4px',
//                                                                         margin: '0 auto'
//                                                                     }}
//                                                                 />
//                                                             </Card.Body>
//                                                             {/* Skeleton for Action Buttons */}
//                                                             <div
//                                                                 className="d-flex justify-content-around p-2"
//                                                                 style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                             >
//                                                                 {[1, 2].map((btnIndex) => (
//                                                                     <div
//                                                                         key={btnIndex}
//                                                                         style={{
//                                                                             width: '60px',
//                                                                             height: '32px',
//                                                                             background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
//                                                                             backgroundSize: '200% 100%',
//                                                                             animation: 'skeletonPulse 1.5s infinite',
//                                                                             borderRadius: '4px',
//                                                                         }}
//                                                                     />
//                                                                 ))}
//                                                             </div>
//                                                         </Card>
//                                                     </Col>
//                                                 ))
//                                             ) : topImageAdd.length === 0 && !bottomImageAdd ? (
//                                                 // Empty State
//                                                 <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px', width: '100%' }}>
//                                                     <div className="text-center">
//                                                         <div className="text-muted mb-2">
//                                                             <i className="bi bi-layout-three-columns" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
//                                                         </div>
//                                                         <p className="text-muted">No top or bottom images found</p>
//                                                     </div>
//                                                 </div>
//                                             ) : (
//                                                 // Actual Top & Bottom Images
//                                                 <>
//                                                     {topImageAdd.map((ad) => (
//                                                         <Col key={ad.id} lg={3} md={4}>
//                                                             <Card
//                                                                 className="h-100"
//                                                                 style={{
//                                                                     border: '1px solid #e9ecef',
//                                                                     borderRadius: '10px',
//                                                                     transition: 'transform 0.2s, box-shadow 0.2s',
//                                                                     cursor: 'pointer',
//                                                                 }}
//                                                                 onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
//                                                                 onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//                                                             >
//                                                                 <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                     <Image
//                                                                         onClick={() => openUpdateImageModal(ad)}
//                                                                         src={ad.adImagePath}
//                                                                         alt="ad-pic"
//                                                                         fluid
//                                                                         style={{
//                                                                             borderRadius: '8px',
//                                                                             maxHeight: '200px',
//                                                                             objectFit: 'cover',
//                                                                         }}
//                                                                     />
//                                                                     <h5
//                                                                         className="mt-3"
//                                                                         style={{ color: '#0d6efd', fontWeight: '600', fontSize: '18px' }}
//                                                                     >
//                                                                         {ad.title.toUpperCase()}
//                                                                     </h5>
//                                                                 </Card.Body>
//                                                                 <div
//                                                                     className="d-flex justify-content-around p-2"
//                                                                     style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                                 >
//                                                                     {(addAccess?.includes("AdvertisementMgt:get") || email === "contact@xpansecafe.com") && (
//                                                                         <Button
//                                                                             variant="light"
//                                                                             title="View"
//                                                                             size='sm'
//                                                                             className='text-success'
//                                                                             style={{ padding: '8px', margin: '0 5px' }}
//                                                                             onClick={() => handleOpenViewModal(ad._id)}
//                                                                         >
//                                                                             <i className="bi bi-eye" style={{ fontSize: '15px' }}></i> View
//                                                                         </Button>
//                                                                     )}
//                                                                     {(addAccess?.includes("AdvertisementMgt:update") || email === "contact@xpansecafe.com") && (
//                                                                         <Button
//                                                                             variant="light"
//                                                                             title="Edit"
//                                                                             size='sm'
//                                                                             className='text-primary'
//                                                                             style={{ padding: '8px', margin: '0 5px' }}
//                                                                             onClick={() => handleOpenEditModal(ad)}
//                                                                         >
//                                                                             <i className="bi bi-pencil" style={{ fontSize: '15px' }}></i> Edit
//                                                                         </Button>
//                                                                     )}
//                                                                     {(addAccess?.includes("AdvertisementMgt:delete") || email === "contact@xpansecafe.com") && (
//                                                                         <Button
//                                                                             variant="light"
//                                                                             title="Delete"
//                                                                             className='text-danger'
//                                                                             onClick={() => handleOpenDeleteModal(ad._id)}
//                                                                             style={{ padding: '8px', margin: '0 5px' }}
//                                                                         >
//                                                                             <i className="bi bi-trash" style={{ fontSize: '15px' }}></i> Delete
//                                                                         </Button>
//                                                                     )}
//                                                                 </div>
//                                                             </Card>
//                                                         </Col>
//                                                     ))}
//                                                     <Col lg={3} md={4}>
//                                                         <Card
//                                                             className="h-100"
//                                                             style={{
//                                                                 border: '1px solid #e9ecef',
//                                                                 borderRadius: '10px',
//                                                                 transition: 'transform 0.2s, box-shadow 0.2s',
//                                                                 cursor: 'pointer',
//                                                             }}
//                                                             onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
//                                                             onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//                                                         >
//                                                             <Card.Body className="text-center" style={{ padding: '20px' }}>
//                                                                 <Image
//                                                                     onClick={() => openUpdateImageModal(bottomImageAdd)}
//                                                                     src={bottomImageAdd?.adImagePath}
//                                                                     alt="ad-pic"
//                                                                     fluid
//                                                                     style={{
//                                                                         borderRadius: '8px',
//                                                                         maxHeight: '200px',
//                                                                         objectFit: 'cover',
//                                                                     }}
//                                                                 />
//                                                                 <h5
//                                                                     className="mt-3"
//                                                                     style={{ color: '#0d6efd', fontWeight: '600', fontSize: '18px' }}
//                                                                 >
//                                                                     {bottomImageAdd?.title?.toUpperCase()}
//                                                                 </h5>
//                                                             </Card.Body>
//                                                             <div
//                                                                 className="d-flex justify-content-around p-2"
//                                                                 style={{ borderTop: '1px solid #e9ecef', padding: '10px' }}
//                                                             >
//                                                                 {(addAccess?.includes("AdvertisementMgt:update") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         variant="light"
//                                                                         title="Edit"
//                                                                         size='sm'
//                                                                         className='text-primary'
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                         onClick={() => handleOpenEditModal(bottomImageAdd)}
//                                                                     >
//                                                                         <i className="bi bi-pencil" style={{ fontSize: '18px' }}></i> Edit
//                                                                     </Button>
//                                                                 )}
//                                                                 {(addAccess?.includes("AdvertisementMgt:delete") || email === "contact@xpansecafe.com") && (
//                                                                     <Button
//                                                                         variant="light"
//                                                                         title="Delete"
//                                                                         className='text-danger'
//                                                                         onClick={() => handleOpenDeleteModal(bottomImageAdd?._id)}
//                                                                         size='sm'
//                                                                         style={{ padding: '8px', margin: '0 5px' }}
//                                                                     >
//                                                                         <i className="bi bi-trash" style={{ fontSize: '18px' }}></i> Delete
//                                                                     </Button>
//                                                                 )}
//                                                             </div>
//                                                         </Card>
//                                                     </Col>
//                                                 </>
//                                             )}
//                                         </Row>
//                                     </Tab>
//                                 </Tabs>

//                             </Container>
//                         {/* </Col> */}
//                     </Row>

//                     {openAddModal ? (
//                         <Modal show={openAddModal} onHide={handleCloseAddModal} centered size="lg">
//                             <Modal.Header closeButton>
//                                 <Modal.Title className="fs-6 fw-semibold pt-1">
//                                     ADD ADVERTISEMENT
//                                 </Modal.Title>
//                             </Modal.Header>
//                             <Form onSubmit={addAdvertisement}>
//                                 <Modal.Body>
//                                     <Row>
//                                     <Col>
//                                         <Form.Group className="mb-3">
//                                         <Form.Label className="fw-semibold">
//                                             Title <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Form.Control
//                                             type="text"
//                                             placeholder="Title"
//                                             name="title"
//                                             value={inputData.title}
//                                             onChange={handleInputChange}
//                                         />
//                                         </Form.Group>
//                                     </Col>
//                                     <Col>
//                                         <Form.Group className="mb-3">
//                                         <Form.Label className="fw-semibold">
//                                             Select Type <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Form.Select
//                                             size="sm"
//                                             onChange={handleInputChange}
//                                             value={inputData?.type}
//                                             name="type"
//                                         >
//                                             <option value="">Select Type</option>
//                                             <option value="CLICKABLE">CLICKABLE</option>
//                                             <option value="NON-CLICKABLE">NON-CLICKABLE</option>
//                                         </Form.Select>
//                                         </Form.Group>
//                                     </Col>
//                                     </Row>
                        
//                                     <Row>
//                                     <Col>
//                                         <Form.Group className="mb-3">
//                                         <Form.Label className="fw-semibold">
//                                             Sequence No. <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Form.Control
//                                             type="number"
//                                             placeholder="Sequence No."
//                                             name="sequenceNo"
//                                             value={inputData?.sequenceNo}
//                                             onChange={handleInputChange}
//                                         />
//                                         </Form.Group>
//                                     </Col>
//                                     {inputData?.type === "NON-CLICKABLE" ? (
//                                         <>
//                                         <Col>
//                                             <Form.Group className="mb-3">
//                                             <Form.Label className="fw-semibold">Top Image</Form.Label>
//                                             <Form.Select
//                                                 size="sm"
//                                                 onChange={handleInputChange}
//                                                 name="isTopImage"
//                                                 value={inputData?.isTopImage}
//                                             >
//                                                 <option value="" disabled>Is it Top Image</option>
//                                                 <option value="true">YES</option>
//                                                 <option value="false">NO</option>
//                                             </Form.Select>
//                                             </Form.Group>
//                                         </Col>
//                                         <Col>
//                                             <Form.Group className="mb-3">
//                                             <Form.Label className="fw-semibold">Bottom Image</Form.Label>
//                                             <Form.Select
//                                                 size="sm"
//                                                 onChange={handleInputChange}
//                                                 name="isBottomImage"
//                                                 value={inputData?.isBottomImage}
//                                             >
//                                                 <option value="" disabled>Is It Bottom Image</option>
//                                                 <option value="true">YES</option>
//                                                 <option value="false">NO</option>
//                                             </Form.Select>
//                                             </Form.Group>
//                                         </Col>
//                                         </>
//                                     ) : (
//                                         <Col>
//                                         <Form.Group className="mb-3">
//                                             <Form.Label className="fw-semibold">
//                                             Select Product <span className="text-danger">*</span>
//                                             </Form.Label>
//                                             <Select
//                                             options={productsList.map((rm) => ({
//                                                 value: rm._id,
//                                                 label: rm.name,
//                                             }))}
//                                             value={
//                                                 inputData?.product
//                                                 ? productsList
//                                                     .map((rm) => ({ value: rm._id, label: rm.name }))
//                                                     .find((option) => option.value === inputData.product)
//                                                 : null
//                                             }
//                                             onChange={(selectedOption) => {
//                                                 if (selectedOption) {
//                                                 handleInputChange({ target: { name: 'product', value: selectedOption.value } });
//                                                 } else {
//                                                 handleInputChange({ target: { name: 'product', value: '' } });
//                                                 }
//                                             }}
//                                             classNamePrefix="react-select"
//                                             isClearable
//                                             placeholder="Select Product"
//                                             />
//                                         </Form.Group>
//                                         </Col>
//                                     )}
//                                     </Row>
                        
//                                     <Row className="mb-2">
//                                     <Col md="3">
//                                         <Form.Group>
//                                         <Form.Label className="fw-semibold">Validity Start Date</Form.Label>
//                                         <DatePicker
//                                             selected={fromDate}
//                                             onChange={handleFromDateChange}
//                                             placeholderText="Start Date"
//                                             className="form-control"
//                                             isClearable
//                                         />
//                                         </Form.Group>
//                                     </Col>
//                                     <Col md="3">
//                                         <Form.Group>
//                                         <Form.Label className="fw-semibold">Validity End Date</Form.Label>
//                                         <DatePicker
//                                             selected={toDate}
//                                             onChange={handleToDateChange}
//                                             placeholderText="End Date"
//                                             className="form-control"
//                                             isClearable
//                                         />
//                                         </Form.Group>
//                                     </Col>
//                                     <Col md="6">
//                                         <Form.Group>
//                                         <Form.Label className="fw-semibold">Select Excluded Outlets</Form.Label>
//                                         <Select
//                                             isMulti
//                                             value={selectedExcludedOutlets}
//                                             onChange={handleSelectChange}
//                                             options={outletData}
//                                             placeholder="Select Excluded Outlets"
//                                             closeMenuOnSelect={false}
//                                         />
//                                         </Form.Group>
//                                     </Col>
//                                     </Row>
                        
//                                     <Row>
//                                     <Col md="6">
//                                         <Form.Group className="mb-3">
//                                         <Form.Label className="fw-semibold">Add Link</Form.Label>
//                                         <Form.Control
//                                             type="text"
//                                             placeholder="Add Link"
//                                             name="link"
//                                             value={inputData.link}
//                                             disabled={inputData.type === "CLICKABLE"}
//                                             onChange={handleInputChange}
//                                         />
//                                         </Form.Group>
//                                     </Col>
//                                     <Col md="6">
//                                         <Form.Group className="mb-3">
//                                         <Form.Label className="fw-semibold">
//                                             Choose File <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Form.Control
//                                             type="file"
//                                             onChange={handleImageChange}
//                                             id="imageInput"
//                                         />
//                                         <p className="text-danger" style={{ fontSize: '13px' }}>Choose an image with 1920x1080 pixels</p>
//                                         </Form.Group>
//                                     </Col>
//                                     </Row>
//                                 </Modal.Body>
//                                 <Modal.Footer>
//                                     <Button variant="primary" type="submit" disabled={isLoading}>
//                                     {isLoading ? <Spinner size='sm' /> : 'ADD ADVERTISEMENT'}
//                                     </Button>
//                                 </Modal.Footer>
//                             </Form>
//                         </Modal>
//                     ) : null}

//                     {openEditModal ? (
//                         <Modal
//                             show={openEditModal}
//                             onHide={() => setOpenEditModal(false)}
//                             centered
//                             size="lg"
//                             aria-labelledby="VerticallyCenteredExample"
//                         >
//                             <Modal.Header closeButton>
//                                 <Modal.Title id="VerticallyCenteredExample" className="fs-6">
//                                     EDIT ADVERTISEMENT
//                                 </Modal.Title>
//                             </Modal.Header>
//                             <Form onSubmit={handleEditSubmit}>
//                                 <Modal.Body>
//                                     {/* Title, Type, and Sequence Number */}
//                                     <Row>
//                                         <Col>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label className="fw-semibold">
//                                                     Title <span className="text-danger">*</span>
//                                                 </Form.Label>
//                                                 <Form.Control
//                                                     type="text"
//                                                     placeholder="Title"
//                                                     name="title"
//                                                     value={editedData?.title || ""}
//                                                     onChange={handleEditChange}
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                         <Col>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label className="fw-semibold">
//                                                     Select Type <span className="text-danger">*</span>
//                                                 </Form.Label>
//                                                 <Form.Select
//                                                     onChange={handleEditChange}
//                                                     value={editedData?.type || ""}
//                                                     name="type"
//                                                 >
//                                                     <option value="">Select Type</option>
//                                                     <option value="CLICKABLE">CLICKABLE</option>
//                                                     <option value="NON-CLICKABLE">NON-CLICKABLE</option>
//                                                 </Form.Select>
//                                             </Form.Group>
//                                         </Col>
//                                         <Col>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label className="fw-semibold">
//                                                     Sequence No. <span className="text-danger">*</span>
//                                                 </Form.Label>
//                                                 <Form.Control
//                                                     type="text"
//                                                     placeholder="Sequence No."
//                                                     name="sequenceNo"
//                                                     value={editedData?.sequenceNo || ""}
//                                                     onChange={handleEditChange}
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                     </Row>

//                                     {/* Validity Start and End Date */}
//                                     <Row className="mb-2">
//                                         <Col>
//                                             <Form.Group>
//                                                 <Form.Label className="fw-semibold">
//                                                     Validity Start Date
//                                                 </Form.Label>
//                                                 <DatePicker
//                                                     selected={fromDate}
//                                                     onChange={handleFromDateChange}
//                                                     placeholderText="Start Date"
//                                                     className="form-control"
//                                                     isClearable
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                         <Col>
//                                             <Form.Group>
//                                                 <Form.Label className="fw-semibold">
//                                                     Validity End Date
//                                                 </Form.Label>
//                                                 <DatePicker
//                                                     selected={toDate}
//                                                     onChange={handleToDateChange}
//                                                     placeholderText="End Date"
//                                                     className="form-control"
//                                                     isClearable
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                     </Row>

//                                     {/* Conditional Rendering for Link, Top Image, and Bottom Image */}
//                                     <Row>
//                                         {editedData?.isTopImage || editedData?.isBottomImage ? (
//                                             <>
//                                                 <Col>
//                                                     <Form.Group>
//                                                         <Form.Label className="fw-semibold">Add Link</Form.Label>
//                                                         <Form.Control
//                                                             type="text"
//                                                             placeholder="Add Link"
//                                                             name="link"
//                                                             value={editedData?.link || ""}
//                                                             disabled={editedData?.type === "NON-CLICKABLE"}
//                                                             onChange={handleEditChange}
//                                                         />
//                                                     </Form.Group>
//                                                 </Col>
//                                                 <Col>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">
//                                                             Top Image <span className="text-danger">*</span>
//                                                         </Form.Label>
//                                                         <Form.Select
//                                                             onChange={handleEditChange}
//                                                             name="isTopImage"
//                                                             value={editedData?.isTopImage || ""}
//                                                         >
//                                                             <option value="">Select</option>
//                                                             <option value="true">YES</option>
//                                                             <option value="false">NO</option>
//                                                         </Form.Select>
//                                                     </Form.Group>
//                                                 </Col>
//                                                 <Col>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">
//                                                             Bottom Image <span className="text-danger">*</span>
//                                                         </Form.Label>
//                                                         <Form.Select
//                                                             onChange={handleEditChange}
//                                                             name="isBottomImage"
//                                                             value={editedData?.isBottomImage || ""}
//                                                         >
//                                                             <option value="">Select</option>
//                                                             <option value="true">YES</option>
//                                                             <option value="false">NO</option>
//                                                         </Form.Select>
//                                                     </Form.Group>
//                                                 </Col>
//                                             </>
//                                         ) : (
//                                             <Col>
//                                                 <Form.Group className="mb-3">
//                                                     <Form.Label className="fw-semibold">
//                                                         Select Product <span className="text-danger">*</span>
//                                                     </Form.Label>
//                                                     <Select
//                                                         options={productsList.map((rm) => ({
//                                                             value: rm._id,
//                                                             label: rm.name,
//                                                         }))}
//                                                         value={
//                                                             editedData?.product
//                                                                 ? productsList
//                                                                     .map((rm) => ({ value: rm._id, label: rm.name }))
//                                                                     .find((option) => option.value === editedData?.product)
//                                                                 : null
//                                                         }
//                                                         onChange={(selectedOption) => {
//                                                             handleEditChange({
//                                                                 target: {
//                                                                     name: 'product',
//                                                                     value: selectedOption ? selectedOption.value : "",
//                                                                 },
//                                                             });
//                                                         }}
//                                                         classNamePrefix="react-select"
//                                                         isDisabled={editedData?.type === "NON-CLICKABLE"}
//                                                         isClearable
//                                                         placeholder="Select Product"
//                                                     />
//                                                 </Form.Group>
//                                             </Col>
//                                         )}
//                                     </Row>

//                                     {/* Excluded Outlets */}
//                                     <Row className="mb-3">
//                                         <Col>
//                                             <Form.Group>
//                                                 <Form.Label className="fw-semibold">
//                                                     Select Excluded Outlets
//                                                 </Form.Label>
//                                                 <Select
//                                                     isMulti
//                                                     value={selectedExcludedOutlets}
//                                                     onChange={handleEditSelectChange}
//                                                     options={outletData}
//                                                     styles={customStyles}
//                                                     placeholder="Select Excluded Outlets"
//                                                     closeMenuOnSelect={false}
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                     </Row>
//                                 </Modal.Body>

//                                 {/* Footer with Save Button */}
//                                 <Modal.Footer>
//                                     <Button variant="primary" type="submit" disabled={isLoading}>
//                                         {isLoading ? <Spinner size="sm" /> : 'SAVE CHANGES'}
//                                     </Button>
//                                 </Modal.Footer>
//                             </Form>
//                         </Modal>
//                     ) : null}

//                     {openViewModal ? (
//                         <Modal
//                             show={openViewModal}
//                             onHide={() => setOpenViewModal(false)}
//                             centered
//                             size="lg"
//                             aria-labelledby="VerticallyCenteredExample"
//                         >
//                             <Modal.Header closeButton>
//                                 <Modal.Title id="VerticallyCenteredExample" className="fs-6">
//                                     VIEW ADVERTISEMENT DETAILS
//                                 </Modal.Title>
//                             </Modal.Header>
//                             <Modal.Body>
//                                 <div>
//                                     <h5 className="text-center">
//                                         {singleAdData?.title && singleAdData.title.toUpperCase()}
//                                     </h5>
//                                 </div>
//                                 <hr />
//                                 <div className="d-flex" style={{ justifyContent: 'space-between' }}>
//                                     {singleAdData?.validityStartDate && singleAdData?.validityEndDate ? (
//                                         <>
//                                             <span className="fw-semibold">
//                                                 Validity Starting From: 
//                                                 <span>
//                                                     {new Date(singleAdData?.validityStartDate).toLocaleDateString('en-GB', {
//                                                         year: 'numeric',
//                                                         month: 'numeric',
//                                                         day: 'numeric',
//                                                     })}
//                                                 </span>
//                                             </span>
//                                             <span className="fw-semibold">
//                                                 Validity Ending On: 
//                                                 <span>
//                                                     {new Date(singleAdData?.validityEndDate).toLocaleDateString('en-GB', {
//                                                         year: 'numeric',
//                                                         month: 'numeric',
//                                                         day: 'numeric',
//                                                         timeZone: 'UTC', // Force UTC timezone
//                                                     })}
//                                                 </span>
//                                             </span>
//                                         </>
//                                     ) : (
//                                         <span className="fw-semibold text-success">NO VALIDITY FOR THIS ADVERTISEMENT</span>
//                                     )}
//                                 </div>
//                                 <div className="d-flex justify-content-center">
//                                     <img
//                                         src={singleAdData?.adImagePath}
//                                         alt="ad-photo"
//                                         className="w-100"
//                                     />
//                                 </div>
//                                 <div className="mt-2">
//                                     <h6>
//                                         Excluded Outlets:{" "}
//                                         <span className="text-danger">
//                                             {singleAdData?.excludedOutlets && singleAdData?.excludedOutlets?.length > 0
//                                                 ? singleAdData?.excludedOutlets?.map(outlet => outlet?.name?.toLowerCase().trim()).join(', ')
//                                                 : "No outlets excluded."}
//                                         </span>
//                                     </h6>
//                                 </div>
//                                 {activeTab === "CLICKABLE" ? (
//                                     <div className="mt-3">
//                                         <Table bordered>
//                                             <thead>
//                                                 <tr>
//                                                     <th className="text-center" colSpan={6}>
//                                                         PRODUCT INFORMATION
//                                                     </th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 <tr>
//                                                     <th className="text-center">IMAGE</th>
//                                                     <th className="text-center">NAME</th>
//                                                     <th className="text-center">DESCRIPTION</th>
//                                                     <th className="text-center">HSN</th>
//                                                     <th className="text-center">MRP</th>
//                                                     <th className="text-center">OFFER PRICE</th>
//                                                 </tr>
//                                                 <tr>
//                                                     <td className="text-center">
//                                                         <img
//                                                             src={singleAdData?.product?.displayImage}
//                                                             alt="product-image"
//                                                             style={{ width: "100px", height: "100px" }}
//                                                         />
//                                                     </td>
//                                                     <td className="text-center">
//                                                         {singleAdData?.product?.name}
//                                                     </td>
//                                                     <td className="text-center">
//                                                         {singleAdData?.product?.description}
//                                                     </td>
//                                                     <td className="text-center">
//                                                         {singleAdData?.product?.hsn}
//                                                     </td>
//                                                     <td className="text-center">
//                                                         {singleAdData?.product?.mrp}
//                                                     </td>
//                                                     <td className="text-center">
//                                                         {singleAdData?.product?.offerPrice} Rs
//                                                     </td>
//                                                 </tr>
//                                             </tbody>
//                                         </Table>
//                                     </div>
//                                 ) : null}
//                             </Modal.Body>
//                             <Modal.Footer>
//                                 <Button
//                                     variant="warning"
//                                     onClick={() => setOpenViewModal(false)}
//                                     style={{ borderRadius: "18px" }}
//                                 >
//                                     CLOSE
//                                 </Button>
//                             </Modal.Footer>
//                         </Modal>
//                     ) : null}

//                     {openDeleteModal && (
//                         <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered>
//                             <Modal.Header closeButton>
//                                 <Modal.Title>Confirm Delete</Modal.Title>
//                             </Modal.Header>
//                             <Modal.Body>
//                                 Are you sure you want to delete this Advertisement? This action cannot be undone.
//                             </Modal.Body>
//                             <Modal.Footer>
//                                 <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
//                                     Cancel
//                                 </Button>
//                                 <Button variant="danger" onClick={deleteAdvertisement}>
//                                     { isDeleteBtnLoading ?
//                                         <Spinner
//                                             as="span"
//                                             animation="border"
//                                             size="sm"
//                                             role="status"
//                                             aria-hidden="true"
//                                         /> :
//                                         "Delete Advertisement"                                
//                                     }
//                                 </Button>
//                             </Modal.Footer>
//                         </Modal>
//                     )}

//                     {isOpenUpdateImageModal && (
//                         <Modal
//                             show={isOpenUpdateImageModal}
//                             onHide={() => setIsOpenUpdateImageModal(false)}
//                             centered
//                             aria-labelledby="VerticallyCenteredExample"
//                         >
//                             <Modal.Header closeButton>
//                                 <Modal.Title id="VerticallyCenteredExample" className="fs-6">
//                                     UPDATE ADVERTISEMENT IMAGE
//                                 </Modal.Title>
//                             </Modal.Header>
//                             <Form >
//                                 <Modal.Body>
//                                     <Form.Group className="mb-3">
//                                         <Form.Label className="fw-semibold">
//                                             Choose File <span className="text-danger">*</span>
//                                         </Form.Label>
//                                         <Form.Control
//                                             type="file"
//                                             onChange={handleEditImageChange}
//                                             id="imageInput"
//                                         />
//                                     </Form.Group>
//                                 </Modal.Body>
//                                 <Modal.Footer>
//                                     <Button variant="primary"  onClick={handleEditImage} disabled={isImageUpdating}>
//                                         {isImageUpdating ? <Spinner size='sm' /> : 'SAVE CHANGES' }
//                                     </Button>
//                                 </Modal.Footer>
//                             </Form>
//                         </Modal>
//                     )}

//                 </div>
//             </div>
//             {/* Add CSS Animation */}
//             <style>
//                 {`
//                     @keyframes skeletonPulse {
//                         0% {
//                             background-position: 200% 0;
//                         }
//                         100% {
//                             background-position: -200% 0;
//                         }
//                     }
                    
//                     .skeleton-card {
//                         pointer-events: none;
//                     }
//                 `}
//             </style>
//         </React.Fragment>
//     )
// }

// export default AdvertisementMgt




// New Design
import React, { useEffect, useMemo, useState } from 'react'
import Header from '../../layouts/Header';
import {
    Badge, Button, Card, Col, Container, Dropdown, Form, FormControl,
    Image, InputGroup, Modal, Row, Spinner, Table
} from 'react-bootstrap';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';
import Select from "react-select";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from 'react-redux';

// ---------- small helpers ----------

const getAdStatus = (ad) => {
    if (ad?._draft) return "DRAFT";
    const now = new Date();
    const start = ad?.validityStartDate ? new Date(ad.validityStartDate) : null;
    const end = ad?.validityEndDate ? new Date(ad.validityEndDate) : null;
    if (start && now < start) return "SCHEDULED";
    if (end && now > end) return "EXPIRED";
    return "ACTIVE";
};

const STATUS_META = {
    ACTIVE: { bg: "#E7F7EE", color: "#1F9254", dot: "#1F9254", label: "Active" },
    EXPIRED: { bg: "#FDEBEC", color: "#D93025", dot: "#D93025", label: "Expired" },
    SCHEDULED: { bg: "#FFF4E5", color: "#B7791F", dot: "#B7791F", label: "Scheduled" },
    DRAFT: { bg: "#F1F2F4", color: "#5F6672", dot: "#5F6672", label: "Draft" },
};

const CATEGORY_META = {
    CLICKABLE: { label: "Clickable", bg: "#EAF1FF", color: "#2A5CD9" },
    NON_CLICKABLE: { label: "Non Clickable", bg: "#F1F2F4", color: "#5F6672" },
    TOP_BANNER: { label: "Top Banner", bg: "#F3EBFF", color: "#7A3FD9" },
    BOTTOM_BANNER: { label: "Bottom Banner", bg: "#FFEFF5", color: "#C23574" },
};

const StatusBadge = ({ status }) => {
    const meta = STATUS_META[status] || STATUS_META.ACTIVE;
    return (
        <span
            className="d-inline-flex align-items-center gap-1 fw-semibold"
            style={{
                background: meta.bg, color: meta.color, borderRadius: 20,
                padding: "3px 10px", fontSize: 12, lineHeight: 1.4,
            }}
        >
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: meta.dot, display: "inline-block" }} />
            {meta.label}
        </span>
    );
};

const CategoryBadge = ({ category }) => {
    const meta = CATEGORY_META[category] || CATEGORY_META.CLICKABLE;
    return (
        <span
            className="fw-semibold"
            style={{
                background: meta.bg, color: meta.color, borderRadius: 6,
                padding: "3px 8px", fontSize: 11.5,
            }}
        >
            {meta.label}
        </span>
    );
};

const fmtDate = (d) => d
    ? new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
    : null;

const PAGE_SIZE = 10;

const AdvertisementMgt = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { loginEmail } = useSelector((state) => state.login);
    const email = loginEmail || localStorage.getItem("email");
    const [addAccess, setAddAccess] = useState([]);

    useEffect(() => {
        if (Array.isArray(access)) {
            setAddAccess(access?.filter((perm) => perm?.startsWith("AdvertisementMgt:")));
        }
    }, [access]);

    const hasPerm = (perm) => addAccess?.includes(`AdvertisementMgt:${perm}`) || email === "contact@xpansecafe.com";

    const accessToken = localStorage.getItem("authToken");

    // ---------- data ----------
    const [listLoading, setListLoading] = useState(false);
    const [clickableAdvertisementData, setClickableAdvertisementData] = useState([]);
    const [nonClickableAdvertisementData, setNonClickableAdvertisementData] = useState([]);
    const [topImageAdd, setTopImageAdd] = useState([]);
    const [bottomImageAdd, setBottomImageAdd] = useState({});
    const [outlets, setOutlets] = useState([]);
    const [productsList, setProductsList] = useState([]);

    // ---------- ui state ----------
    const [activeTab, setActiveTab] = useState("ALL");
    const [searchText, setSearchText] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [outletFilter, setOutletFilter] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);
    const [previewAd, setPreviewAd] = useState(null);
    const [page, setPage] = useState(1);
    const [isRefreshBtnLoading, setIsRefreshBtnLoading] = useState(false);

    // ---------- modals ----------
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [isOpenUpdateImageModal, setIsOpenUpdateImageModal] = useState(false);

    const [inputData, setInputData] = useState({
        title: "", type: "", sequenceNo: "", product: "",
        isTopImage: "", isBottomImage: "", link: ""
    });
    const [editedData, setEditedData] = useState({});
    const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [singleAdData, setSingleAdData] = useState("");
    const [adId, setAdId] = useState('');
    const [image, setImage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [isImageUpdating, setIsImageUpdating] = useState(false);

    const customStyles = {
        control: (provided, state) => ({
            ...provided, width: "100%", borderRadius: "8px", minWidth: "180px",
            borderColor: state.isFocused ? "#80bdff" : "#e1e4e8", fontSize: 14,
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.15)" : null,
        }),
        placeholder: (provided) => ({ ...provided, color: "#8a93a3", fontSize: 14 }),
    };

    // ---------- API ----------

    const getAdvertisementList = async () => {
        setListLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("advertisement", { headers });
            if (response?.data?.status === true) {
                const totalNonClickable = response?.data?.data?.advertisements?.nonClickableAdvertisements || [];
                const nonClickable = totalNonClickable.filter(ad => ad.isTopImage === false && ad.isBottomImage === false);
                const top = totalNonClickable.filter(ad => ad.isTopImage === true);
                const bottom = totalNonClickable.find(ad => ad.isBottomImage === true);

                setClickableAdvertisementData(response?.data?.data?.advertisements?.clickableAdvertisements || []);
                setNonClickableAdvertisementData(nonClickable);
                setTopImageAdd(top);
                setBottomImageAdd(bottom || {});
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                toast.error(error.response.data.error, { position: "top-right", autoClose: 3000, theme: "colored" });
            }
        } finally {
            setListLoading(false);
        }
    };

    const getOutlets = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("outlet", { headers });
            if (response?.data?.status === true) {
                setOutlets(response?.data?.data?.outlets?.filter((o) => o?.status === "ACTIVE") || []);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                toast.error(error.response.data.error, { position: "top-right", autoClose: 3000, theme: "colored" });
            }
        }
    };

    const getProductsList = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("product", { headers });
            if (response?.data?.status === true) setProductsList(response?.data?.data?.products || []);
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                toast.error(error.response.data.error, { position: "top-right", autoClose: 3000, theme: "colored" });
            }
        }
    };

    const getSingleAdvertisement = async (id) => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get(`advertisement?_id=${id}`, { headers });
            if (response?.data?.status === true) setSingleAdData(response?.data?.data?.advertisements);
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                toast.error(error.response.data.error, { position: "top-right", autoClose: 3000, theme: "colored" });
            }
        }
    };

    const handleRefresh = async () => {
        setIsRefreshBtnLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get('advertisement/clear-advertisement-cache', { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.message, { position: "top-right", autoClose: 3000, theme: "colored" });
            }
        } catch (error) {
            if (error?.response) {
                const msg = error?.response?.data?.error?.message || error?.response?.data?.error || error?.response?.data?.data?.message;
                toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });
            }
        } finally {
            setIsRefreshBtnLoading(false);
        }
    };

    useEffect(() => {
        getAdvertisementList();
        getOutlets();
        getProductsList();
    }, []);

    // ---------- unified list for the table ----------

    const allAds = useMemo(() => {
        const clickable = clickableAdvertisementData.map(ad => ({ ...ad, _category: 'CLICKABLE' }));
        const nonClickable = nonClickableAdvertisementData.map(ad => ({ ...ad, _category: 'NON_CLICKABLE' }));
        const top = topImageAdd.map(ad => ({ ...ad, _category: 'TOP_BANNER' }));
        const bottom = bottomImageAdd && bottomImageAdd._id ? [{ ...bottomImageAdd, _category: 'BOTTOM_BANNER' }] : [];
        return [...clickable, ...nonClickable, ...top, ...bottom];
    }, [clickableAdvertisementData, nonClickableAdvertisementData, topImageAdd, bottomImageAdd]);

    const counts = useMemo(() => {
        const c = { ALL: allAds.length, CLICKABLE: 0, NON_CLICKABLE: 0, TOP_BANNER: 0, BOTTOM_BANNER: 0 };
        const s = { ACTIVE: 0, EXPIRED: 0, SCHEDULED: 0 };
        allAds.forEach(ad => {
            c[ad._category] = (c[ad._category] || 0) + 1;
            const st = getAdStatus(ad);
            s[st] = (s[st] || 0) + 1;
        });
        return { ...c, ...s };
    }, [allAds]);

    const filteredAds = useMemo(() => {
        let list = allAds;
        if (activeTab !== "ALL") list = list.filter(ad => ad._category === activeTab);
        if (statusFilter) list = list.filter(ad => getAdStatus(ad) === statusFilter);
        if (outletFilter) {
            list = list.filter(ad => !(ad.excludedOutlets || []).some(o => o._id === outletFilter.value));
        }
        if (searchText.trim()) {
            const q = searchText.toLowerCase();
            list = list.filter(ad => ad.title?.toLowerCase().includes(q) || ad.product?.name?.toLowerCase().includes(q));
        }
        return list;
    }, [allAds, activeTab, statusFilter, outletFilter, searchText]);

    const totalPages = Math.max(1, Math.ceil(filteredAds.length / PAGE_SIZE));
    const pagedAds = filteredAds.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    useEffect(() => { setPage(1); }, [activeTab, statusFilter, outletFilter, searchText]);

    const clearFilters = () => {
        setStatusFilter(""); setOutletFilter(null); setSearchText("");
    };

    const toggleSelectAll = (checked) => {
        setSelectedIds(checked ? pagedAds.map(a => a._id) : []);
    };
    const toggleSelectRow = (id) => {
        setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };

    // ---------- form handlers (Add) ----------

    const outletData = outlets?.map((o) => ({ value: o._id, label: `${o.name} (${o.city})` }));

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputData((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageChange = () => {
        const input = document.getElementById("imageInput");
        const file = input.files[0];
        if (file) setImage(file);
    };

    const handleOpenAddModal = () => setOpenAddModal(true);

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
        setInputData({ title: "", type: "", sequenceNo: "", product: "", isTopImage: "", isBottomImage: "", link: "" });
        setFromDate(null); setToDate(null); setSelectedExcludedOutlets([]); setImage(null);
    };

    const addAdvertisement = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const updatedStartDate = fromDate
                ? new Date(fromDate.getTime() - fromDate.getTimezoneOffset() * 60000).toISOString().split("T")[0] : null;
            const updatedEndDate = toDate
                ? new Date(toDate.getTime() - toDate.getTimezoneOffset() * 60000).toISOString().split("T")[0] : null;

            const selectOutlets = selectedExcludedOutlets.map((val) => val?.value);
            const newInputData = { ...inputData, excludedOutlets: selectOutlets };

            const formData = new FormData();
            formData.append("title", newInputData.title);
            formData.append("type", newInputData.type);
            formData.append("sequenceNo", newInputData.sequenceNo);
            if (updatedStartDate !== null) formData.append("validityStartDate", updatedStartDate);
            if (updatedEndDate !== null) formData.append("validityEndDate", updatedEndDate);
            if (newInputData?.product !== "") formData.append("product", newInputData.product);
            if (newInputData?.isTopImage !== "") formData.append("isTopImage", newInputData.isTopImage);
            if (newInputData?.isBottomImage !== "") formData.append("isBottomImage", newInputData.isBottomImage);
            if (newInputData?.link !== "") formData.append("link", newInputData.link);
            formData.append("adImage", image);
            if (selectOutlets?.length > 0) {
                selectOutlets.forEach((outlet, index) => formData.append(`excludedOutlets[${index}]`, outlet));
            }

            const headers = { "Content-Type": "multipart/form-data", Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.post("advertisement", formData, { headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, { position: "top-right", autoClose: 3000, theme: "light" });
                getAdvertisementList();
                handleCloseAddModal();
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                else if (error.response?.status === 412) errorMessage = error?.response?.data?.data?.message;
                else if (error.response?.status === 500) errorMessage = error?.response?.data?.error;
                toast.error(errorMessage, { position: "top-right", autoClose: 3000, theme: "light" });
            }
        } finally {
            setIsLoading(false);
        }
    };

    // ---------- edit ----------

    const handleOpenEditModal = (data) => {
        setOpenEditModal(true);
        setEditedData({
            _id: data?._id, title: data?.title, type: data?.type, sequenceNo: data?.sequenceNo,
            product: data?.product?._id, isTopImage: data?.isTopImage, isBottomImage: data?.isBottomImage, link: data?.link
        });
        setFromDate(data?.validityStartDate ? new Date(data.validityStartDate) : null);
        setToDate(data?.validityEndDate
            ? new Date(new Date(data.validityEndDate).setDate(new Date(data.validityEndDate).getDate() - 1)) : null);
        const mapped = data?.excludedOutlets?.map((m) => ({ value: m?._id, label: m?.name }));
        setSelectedExcludedOutlets(mapped);
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedData((prev) => ({ ...prev, [name]: value }));
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            if ((fromDate && !toDate) || (!fromDate && toDate)) {
                toast.error("Please select both start date and end date", { position: "top-right", autoClose: 3000, theme: "colored" });
                setIsLoading(false);
                return;
            }
            const updatedStartDate = fromDate
                ? new Date(fromDate.getTime() - fromDate.getTimezoneOffset() * 60000).toISOString().split("T")[0] : null;
            const updatedEndDate = toDate
                ? new Date(toDate.getTime() - toDate.getTimezoneOffset() * 60000).toISOString().split("T")[0] : null;

            const selectedExOutlets = selectedExcludedOutlets?.map((ex) => ex?.value);
            const newEditedData = { ...editedData, excludedOutlets: selectedExOutlets };

            const formData = new FormData();
            formData.append("_id", newEditedData?._id);
            formData.append("title", newEditedData.title);
            formData.append("type", newEditedData.type);
            formData.append("sequenceNo", newEditedData.sequenceNo);
            formData.append("validityStartDate", updatedStartDate);
            formData.append("validityEndDate", updatedEndDate);
            if (newEditedData?.product) formData.append("product", newEditedData?.product);
            if (newEditedData?.isTopImage !== "") formData.append("isTopImage", newEditedData?.isTopImage);
            if (newEditedData?.link !== "") formData.append("link", newEditedData?.link);
            if (newEditedData?.isBottomImage !== "") formData.append("isBottomImage", newEditedData?.isBottomImage);

            if (!selectedExOutlets?.length) formData.append("excludedOutlets", null);
            else selectedExOutlets.forEach((outlet, index) => formData.append(`excludedOutlets[${index}]`, outlet));

            const headers = { "Content-Type": "multipart/form-data", Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.put("advertisement", formData, { headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, { position: "top-right", autoClose: 3000, theme: "colored" });
                setOpenEditModal(false);
                getAdvertisementList();
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                else if (error.response?.status === 404) errorMessage = error?.response?.data?.data?.message;
                else if (error.response?.status === 412) errorMessage = error?.response?.data?.data?.message;
                else if (error.response?.status === 500) errorMessage = error?.response?.data?.error;
                toast.error(errorMessage, { position: "top-right", autoClose: 3000, theme: "colored" });
            }
        } finally {
            setIsLoading(false);
        }
    };

    // ---------- view / delete / image ----------

    const handleOpenViewModal = (id) => { setOpenViewModal(true); getSingleAdvertisement(id); };

    const handleOpenDeleteModal = (id) => { setOpenDeleteModal(true); setAdId(id); };

    const deleteAdvertisement = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.delete(`advertisement`, { data: { _id: adId }, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, { position: "top-right", autoClose: 3000, theme: "colored" });
                getAdvertisementList();
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                else if (error.response?.status === 412) errorMessage = error?.response?.data?.data?.message;
                else if (error.response?.status === 500) errorMessage = error?.response?.data?.error;
                toast.error(errorMessage, { position: "top-right", autoClose: 3000, theme: "colored" });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const openUpdateImageModal = (data) => {
        setEditedData((prev) => ({ ...prev, _id: data?._id }));
        setIsOpenUpdateImageModal(true);
    };

    const handleEditImageChange = (e) => {
        const input = document.getElementById("imageInput");
        const file = input.files[0];
        if (file) setImage(file);
    };

    const handleEditImage = async () => {
        setIsImageUpdating(true);
        try {
            const formData = new FormData();
            formData.append("_id", editedData?._id);
            formData.append("adImage", image);
            const headers = { "Content-Type": "multipart/form-data", Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.put(`advertisement`, formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, { position: "top-right", autoClose: 3000, theme: "colored" });
                setIsOpenUpdateImageModal(false);
                getAdvertisementList();
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                else if (error.response?.status === 412) errorMessage = error?.response?.data?.data?.message;
                else if (error.response?.status === 500) errorMessage = error?.response?.data?.error;
                toast.error(errorMessage, { position: "top-right", autoClose: 3000, theme: "colored" });
            }
        } finally {
            setIsImageUpdating(false);
        }
    };

    // ---------- render ----------

    const statCards = [
        { label: "Total Ads", value: counts.ALL, icon: "bi-grid", color: "#2A5CD9" },
        { label: "Active", value: counts.ACTIVE || 0, icon: "bi-check-circle", color: "#1F9254" },
        { label: "Scheduled", value: counts.SCHEDULED || 0, icon: "bi-clock", color: "#B7791F" },
        { label: "Expired", value: counts.EXPIRED || 0, icon: "bi-x-circle", color: "#D93025" },
    ];

    const tabs = [
        { key: "ALL", label: "All", count: counts.ALL },
        { key: "CLICKABLE", label: "Clickable", count: counts.CLICKABLE },
        { key: "NON_CLICKABLE", label: "Non Clickable", count: counts.NON_CLICKABLE },
        { key: "TOP_BANNER", label: "Top Banner", count: counts.TOP_BANNER },
        { key: "BOTTOM_BANNER", label: "Bottom Banner", count: counts.BOTTOM_BANNER },
    ];

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4" style={{ background: "#F5F6F8" }}>

                {/* Page header */}
                <Row className="align-items-center mb-3">
                    <Col>
                        <h4 className="fw-bold mb-1" style={{ color: "#1B1F27" }}>Advertisement Management</h4>
                        <p className="text-muted mb-0" style={{ fontSize: 14 }}>Create, manage and monitor all advertisements</p>
                    </Col>
                    <Col xs="auto" className="d-flex gap-2">
                        <Button
                            variant="outline-secondary"
                            className="fw-semibold d-flex align-items-center"
                            onClick={handleRefresh}
                            disabled={isRefreshBtnLoading}
                        >
                            {isRefreshBtnLoading ? <Spinner size="sm" /> : (
                                <><i className="ri-refresh-line me-1" /> Clear Cache</>
                            )}
                        </Button>
                        {hasPerm("add") && (
                            <Button variant="primary" className="fw-semibold" onClick={handleOpenAddModal}>
                                <i className="ri-add-line me-1" /> Add New Advertisement
                            </Button>
                        )}
                    </Col>
                </Row>

                {/* Search + filters */}
                <Card className="border-0 shadow-sm mb-3" style={{ borderRadius: 12 }}>
                    <Card.Body className="py-3">
                        <Row className="g-2 align-items-center">
                            <Col md={4}>
                                <InputGroup>
                                    <InputGroup.Text style={{ background: "#fff", borderRight: "none" }}>
                                        <i className="bi bi-search text-muted" />
                                    </InputGroup.Text>
                                    <FormControl
                                        placeholder="Search by title or product..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        style={{ borderLeft: "none" }}
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <Form.Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                                    <option value="">All Status</option>
                                    <option value="ACTIVE">Active</option>
                                    <option value="SCHEDULED">Scheduled</option>
                                    <option value="EXPIRED">Expired</option>
                                </Form.Select>
                            </Col>
                            <Col md={3}>
                                <Select
                                    styles={customStyles}
                                    options={outletData}
                                    value={outletFilter}
                                    onChange={setOutletFilter}
                                    isClearable
                                    placeholder="Filter by Outlet"
                                />
                            </Col>
                            <Col md={2} className="d-flex justify-content-end">
                                <Button variant="light" className="fw-semibold border" onClick={clearFilters}>
                                    Clear
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                <Row className="g-3">
                    {/* Table column */}
                    <Col lg={previewAd ? 8 : 12}>
                        <Card className="border-0 shadow-sm" style={{ borderRadius: 12 }}>
                            {/* Tabs */}
                            <div className="d-flex flex-wrap gap-1 px-3 pt-3">
                                {tabs.map(t => (
                                    <button
                                        key={t.key}
                                        onClick={() => setActiveTab(t.key)}
                                        className="border-0 fw-semibold"
                                        style={{
                                            background: activeTab === t.key ? "#EAF1FF" : "transparent",
                                            color: activeTab === t.key ? "#2A5CD9" : "#5F6672",
                                            borderRadius: 8, padding: "6px 14px", fontSize: 13.5,
                                        }}
                                    >
                                        {t.label} <span className="ms-1" style={{ opacity: 0.7 }}>({t.count || 0})</span>
                                    </button>
                                ))}
                            </div>
                            <hr className="mt-3 mb-0" />

                            <div className="table-responsive">
                                <Table hover className="mb-0 align-middle">
                                    <thead>
                                        <tr style={{ fontSize: 12.5, color: "#8A93A3" }}>
                                            <th className="ps-3" style={{ width: 36 }}>
                                                SR.NO
                                            </th>
                                            <th>ADVERTISEMENT</th>
                                            <th>TYPE</th>
                                            <th>STATUS</th>
                                            <th>VALIDITY</th>
                                            <th>EXCLUDED OUTLETS</th>
                                            <th className="text-end pe-3">ACTIONS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listLoading ? (
                                            Array.from({ length: 5 }).map((_, i) => (
                                                <tr key={i}>
                                                    <td colSpan={7} className="py-3">
                                                        <div style={{
                                                            height: 18, borderRadius: 6, width: "100%",
                                                            background: "linear-gradient(90deg,#f0f0f0 25%,#e6e6e6 50%,#f0f0f0 75%)",
                                                            backgroundSize: "200% 100%", animation: "skeletonPulse 1.5s infinite"
                                                        }} />
                                                    </td>
                                                </tr>
                                            ))
                                        ) : pagedAds.length === 0 ? (
                                            <tr>
                                                <td colSpan={7} className="text-center text-muted py-5">
                                                    <i className="bi bi-megaphone d-block mb-2" style={{ fontSize: "2rem", opacity: 0.4 }} />
                                                    No advertisements found
                                                </td>
                                            </tr>
                                        ) : pagedAds.map((ad, index) => {
                                            const status = getAdStatus(ad);
                                            return (
                                                <tr
                                                    key={ad._id}
                                                    onClick={() => setPreviewAd(ad)}
                                                    style={{ cursor: "pointer", background: previewAd?._id === ad._id ? "#F5F8FF" : "transparent" }}
                                                >
                                                    <td className="ps-3" onClick={(e) => e.stopPropagation()}>
                                                        {index + 1 + (page - 1) * PAGE_SIZE}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <Image
                                                                src={ad.adImagePath}
                                                                alt="ad"
                                                                style={{ width: '120px', height: '80px', objectFit: "contain", borderRadius: 6, border: "1px solid #eee" }}
                                                            />
                                                            <div>
                                                                <div className="fw-semibold" style={{ fontSize: 13.5, color: "#1B1F27" }}>{ad.title}</div>
                                                                <div className="text-muted" style={{ fontSize: 12 }}>{ad.product?.name || "—"}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td><CategoryBadge category={ad._category} /></td>
                                                    <td><StatusBadge status={status} /></td>
                                                    <td style={{ fontSize: 13 }}>
                                                        {ad.validityStartDate && ad.validityEndDate
                                                            ? `${fmtDate(ad.validityStartDate)} – ${fmtDate(ad.validityEndDate)}`
                                                            : <span className="text-muted">No expiry</span>}
                                                    </td>
                                                    <td style={{ fontSize: 13 }}>
                                                        {ad.excludedOutlets?.length ? `${ad.excludedOutlets.length} outlet(s)` : "All Outlets"}
                                                    </td>
                                                    <td className="text-end pe-3" onClick={(e) => e.stopPropagation()}>
                                                        <Dropdown align="end">
                                                            <Dropdown.Toggle variant="link" className="p-0 text-secondary">
                                                                <i className="ri-more-2-fill" style={{ fontSize: 18 }} />
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {hasPerm("get") && (
                                                                    <Dropdown.Item onClick={() => handleOpenViewModal(ad._id)}>
                                                                        <i className="bi bi-eye me-2" /> View
                                                                    </Dropdown.Item>
                                                                )}
                                                                {hasPerm("update") && (
                                                                    <Dropdown.Item onClick={() => handleOpenEditModal(ad)}>
                                                                        <i className="bi bi-pencil me-2" /> Edit
                                                                    </Dropdown.Item>
                                                                )}
                                                                {hasPerm("update") && (
                                                                    <Dropdown.Item onClick={() => openUpdateImageModal(ad)}>
                                                                        <i className="bi bi-image me-2" /> Change Image
                                                                    </Dropdown.Item>
                                                                )}
                                                                {hasPerm("delete") && (
                                                                    <Dropdown.Item className="text-danger" onClick={() => handleOpenDeleteModal(ad._id)}>
                                                                        <i className="bi bi-trash me-2" /> Delete
                                                                    </Dropdown.Item>
                                                                )}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>

                            {/* Footer / pagination */}
                            <div className="d-flex justify-content-between align-items-center px-3 py-3">
                                <span className="text-muted" style={{ fontSize: 13 }}>
                                    Showing {filteredAds.length === 0 ? 0 : (page - 1) * PAGE_SIZE + 1} to{" "}
                                    {Math.min(page * PAGE_SIZE, filteredAds.length)} of {filteredAds.length} results
                                </span>
                                <div className="d-flex align-items-center gap-1">
                                    <Button variant="light" size="sm" className="border" disabled={page === 1}
                                        onClick={() => setPage(p => Math.max(1, p - 1))}>
                                        <i className="bi bi-chevron-left" />
                                    </Button>
                                    {Array.from({ length: totalPages }).slice(0, 5).map((_, i) => (
                                        <Button
                                            key={i}
                                            size="sm"
                                            variant={page === i + 1 ? "primary" : "light"}
                                            className={page === i + 1 ? "" : "border"}
                                            onClick={() => setPage(i + 1)}
                                        >
                                            {i + 1}
                                        </Button>
                                    ))}
                                    <Button variant="light" size="sm" className="border" disabled={page === totalPages}
                                        onClick={() => setPage(p => Math.min(totalPages, p + 1))}>
                                        <i className="bi bi-chevron-right" />
                                    </Button>
                                </div>
                            </div>
                        </Card>
                    </Col>

                    {/* Preview panel */}
                    {previewAd && (
                        <Col lg={4}>
                            <Card className="border-0 shadow-sm" style={{ borderRadius: 12, position: "sticky", top: 16 }}>
                                <Card.Body>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="fw-bold mb-0">Preview & Details</h6>
                                        <Button variant="link" className="p-0 text-secondary" onClick={() => setPreviewAd(null)}>
                                            <i className="bi bi-x-lg" />
                                        </Button>
                                    </div>

                                    <div
                                        className="position-relative"
                                        style={{ cursor: hasPerm("update") ? "pointer" : "default", marginBottom: 12 }}
                                        onClick={() => hasPerm("update") && openUpdateImageModal(previewAd)}
                                        title={hasPerm("update") ? "Click to change image" : undefined}
                                    >
                                        <Image src={previewAd.adImagePath} fluid style={{ borderRadius: 10, width: "100%", display: "block" }} />
                                        {hasPerm("update") && (
                                            <div
                                                className="position-absolute d-flex align-items-center justify-content-center"
                                                style={{
                                                    inset: 0, borderRadius: 10, background: "rgba(0,0,0,0)",
                                                    transition: "background 0.15s ease",
                                                }}
                                                onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(27,31,39,0.45)"; e.currentTarget.querySelector('span').style.opacity = 1; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(0,0,0,0)"; e.currentTarget.querySelector('span').style.opacity = 0; }}
                                            >
                                                <span
                                                    className="d-inline-flex align-items-center gap-1 fw-semibold text-white"
                                                    style={{
                                                        opacity: 0, transition: "opacity 0.15s ease", fontSize: 13,
                                                        background: "rgba(27,31,39,0.85)", borderRadius: 20, padding: "5px 12px",
                                                    }}
                                                >
                                                    <i className="bi bi-pencil" /> Change Image
                                                </span>
                                            </div>
                                        )}
                                    </div>

                                    {[
                                        ["Advertisement Name", previewAd.title],
                                        ["Category", <CategoryBadge category={previewAd._category} />],
                                        ["Status", <StatusBadge status={getAdStatus(previewAd)} />],
                                        ["Validity", previewAd.validityStartDate
                                            ? `${fmtDate(previewAd.validityStartDate)} – ${fmtDate(previewAd.validityEndDate)}`
                                            : "No expiry"],
                                        ["Product", previewAd.product?.name || "—"],
                                        ["Sequence No.", previewAd.sequenceNo ?? "—"],
                                        ["Excluded Outlets", previewAd.excludedOutlets?.length
                                            ? previewAd.excludedOutlets.map(o => o.name).join(", ") : "None"],
                                    ].map(([label, value]) => (
                                        <div key={label} className="d-flex justify-content-between py-2" style={{ borderBottom: "1px solid #F1F2F4", fontSize: 13.5 }}>
                                            <span className="text-muted">{label}</span>
                                            <span className="fw-semibold text-end" style={{ maxWidth: "60%" }}>{value}</span>
                                        </div>
                                    ))}

                                    <div className="d-flex gap-2 mt-3">
                                        {hasPerm("update") && (
                                            <Button variant="outline-primary" size="sm" className="flex-fill" onClick={() => handleOpenEditModal(previewAd)}>
                                                <i className="bi bi-pencil me-1" /> Edit
                                            </Button>
                                        )}
                                        {hasPerm("delete") && (
                                            <Button variant="outline-danger" size="sm" className="flex-fill" onClick={() => handleOpenDeleteModal(previewAd._id)}>
                                                <i className="bi bi-trash me-1" /> Delete
                                            </Button>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    )}
                </Row>

                {/* ---------------- Add Modal ---------------- */}
                {openAddModal && (
                    <Modal show={openAddModal} onHide={handleCloseAddModal} centered size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title className="fs-6 fw-semibold pt-1">ADD ADVERTISEMENT</Modal.Title>
                        </Modal.Header>
                        <Form onSubmit={addAdvertisement}>
                            <Modal.Body>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Title <span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Title" name="title" value={inputData.title} onChange={handleInputChange} />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Select Type <span className="text-danger">*</span></Form.Label>
                                            <Form.Select size="sm" onChange={handleInputChange} value={inputData?.type} name="type">
                                                <option value="">Select Type</option>
                                                <option value="CLICKABLE">CLICKABLE</option>
                                                <option value="NON-CLICKABLE">NON-CLICKABLE</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Sequence No. <span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="number" placeholder="Sequence No." name="sequenceNo" value={inputData?.sequenceNo} onChange={handleInputChange} />
                                        </Form.Group>
                                    </Col>
                                    {inputData?.type === "NON-CLICKABLE" ? (
                                        <>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">Top Image</Form.Label>
                                                    <Form.Select size="sm" onChange={handleInputChange} name="isTopImage" value={inputData?.isTopImage}>
                                                        <option value="" disabled>Is it Top Image</option>
                                                        <option value="true">YES</option>
                                                        <option value="false">NO</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">Bottom Image</Form.Label>
                                                    <Form.Select size="sm" onChange={handleInputChange} name="isBottomImage" value={inputData?.isBottomImage}>
                                                        <option value="" disabled>Is It Bottom Image</option>
                                                        <option value="true">YES</option>
                                                        <option value="false">NO</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </>
                                    ) : (
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">Select Product <span className="text-danger">*</span></Form.Label>
                                                <Select
                                                    options={productsList.map((rm) => ({ value: rm._id, label: rm.name }))}
                                                    value={inputData?.product
                                                        ? productsList.map((rm) => ({ value: rm._id, label: rm.name })).find((o) => o.value === inputData.product)
                                                        : null}
                                                    onChange={(opt) => handleInputChange({ target: { name: 'product', value: opt ? opt.value : '' } })}
                                                    classNamePrefix="react-select"
                                                    isClearable
                                                    placeholder="Select Product"
                                                />
                                            </Form.Group>
                                        </Col>
                                    )}
                                </Row>
                                <Row className="mb-2">
                                    <Col md="3">
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Validity Start Date</Form.Label>
                                            <DatePicker selected={fromDate} onChange={setFromDate} placeholderText="Start Date" className="form-control" isClearable />
                                        </Form.Group>
                                    </Col>
                                    <Col md="3">
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Validity End Date</Form.Label>
                                            <DatePicker selected={toDate} onChange={setToDate} placeholderText="End Date" className="form-control" isClearable />
                                        </Form.Group>
                                    </Col>
                                    <Col md="6">
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Select Excluded Outlets</Form.Label>
                                            <Select isMulti value={selectedExcludedOutlets} onChange={setSelectedExcludedOutlets}
                                                options={outletData} placeholder="Select Excluded Outlets" closeMenuOnSelect={false} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Add Link</Form.Label>
                                            <Form.Control type="text" placeholder="Add Link" name="link" value={inputData.link}
                                                disabled={inputData.type === "CLICKABLE"} onChange={handleInputChange} />
                                        </Form.Group>
                                    </Col>
                                    <Col md="6">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Choose File <span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="file" onChange={handleImageChange} id="imageInput" />
                                            <p className="text-danger" style={{ fontSize: '13px' }}>Choose an image with 1920x1080 pixels</p>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" type="submit" disabled={isLoading}>
                                    {isLoading ? <Spinner size='sm' /> : 'ADD ADVERTISEMENT'}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                )}

                {/* ---------------- Edit Modal ---------------- */}
                {openEditModal && (
                    <Modal show={openEditModal} onHide={() => setOpenEditModal(false)} centered size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title className="fs-6">EDIT ADVERTISEMENT</Modal.Title>
                        </Modal.Header>
                        <Form onSubmit={handleEditSubmit}>
                            <Modal.Body>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Title <span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Title" name="title" value={editedData?.title || ""} onChange={handleEditChange} />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Select Type <span className="text-danger">*</span></Form.Label>
                                            <Form.Select onChange={handleEditChange} value={editedData?.type || ""} name="type">
                                                <option value="">Select Type</option>
                                                <option value="CLICKABLE">CLICKABLE</option>
                                                <option value="NON-CLICKABLE">NON-CLICKABLE</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Sequence No. <span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Sequence No." name="sequenceNo" value={editedData?.sequenceNo || ""} onChange={handleEditChange} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Validity Start Date</Form.Label>
                                            <DatePicker selected={fromDate} onChange={setFromDate} placeholderText="Start Date" className="form-control" isClearable />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Validity End Date</Form.Label>
                                            <DatePicker selected={toDate} onChange={setToDate} placeholderText="End Date" className="form-control" isClearable />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    {editedData?.isTopImage || editedData?.isBottomImage ? (
                                        <>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Add Link</Form.Label>
                                                    <Form.Control type="text" placeholder="Add Link" name="link" value={editedData?.link || ""}
                                                        disabled={editedData?.type === "NON-CLICKABLE"} onChange={handleEditChange} />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">Top Image <span className="text-danger">*</span></Form.Label>
                                                    <Form.Select onChange={handleEditChange} name="isTopImage" value={editedData?.isTopImage || ""}>
                                                        <option value="">Select</option>
                                                        <option value="true">YES</option>
                                                        <option value="false">NO</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">Bottom Image <span className="text-danger">*</span></Form.Label>
                                                    <Form.Select onChange={handleEditChange} name="isBottomImage" value={editedData?.isBottomImage || ""}>
                                                        <option value="">Select</option>
                                                        <option value="true">YES</option>
                                                        <option value="false">NO</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </>
                                    ) : (
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">Select Product <span className="text-danger">*</span></Form.Label>
                                                <Select
                                                    options={productsList.map((rm) => ({ value: rm._id, label: rm.name }))}
                                                    value={editedData?.product
                                                        ? productsList.map((rm) => ({ value: rm._id, label: rm.name })).find((o) => o.value === editedData?.product)
                                                        : null}
                                                    onChange={(opt) => handleEditChange({ target: { name: 'product', value: opt ? opt.value : "" } })}
                                                    classNamePrefix="react-select"
                                                    isDisabled={editedData?.type === "NON-CLICKABLE"}
                                                    isClearable
                                                    placeholder="Select Product"
                                                />
                                            </Form.Group>
                                        </Col>
                                    )}
                                </Row>
                                <Row className="mb-3">
                                    <Col>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Select Excluded Outlets</Form.Label>
                                            <Select isMulti value={selectedExcludedOutlets} onChange={setSelectedExcludedOutlets}
                                                options={outletData} styles={customStyles} placeholder="Select Excluded Outlets" closeMenuOnSelect={false} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" type="submit" disabled={isLoading}>
                                    {isLoading ? <Spinner size="sm" /> : 'SAVE CHANGES'}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                )}

                {/* ---------------- View Modal ---------------- */}
                {openViewModal && (
                    <Modal show={openViewModal} onHide={() => setOpenViewModal(false)} centered size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title className="fs-6">VIEW ADVERTISEMENT DETAILS</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h5 className="text-center">{singleAdData?.title?.toUpperCase()}</h5>
                            <hr />
                            <div className="d-flex justify-content-between">
                                {singleAdData?.validityStartDate && singleAdData?.validityEndDate ? (
                                    <>
                                        <span className="fw-semibold">Validity Starting From: {fmtDate(singleAdData?.validityStartDate)}</span>
                                        <span className="fw-semibold">Validity Ending On: {fmtDate(singleAdData?.validityEndDate)}</span>
                                    </>
                                ) : (
                                    <span className="fw-semibold text-success">NO VALIDITY FOR THIS ADVERTISEMENT</span>
                                )}
                            </div>
                            <div className="d-flex justify-content-center mt-2">
                                <img src={singleAdData?.adImagePath} alt="ad" className="w-100" style={{ borderRadius: 8 }} />
                            </div>
                            <div className="mt-2">
                                <h6>Excluded Outlets: <span className="text-danger">
                                    {singleAdData?.excludedOutlets?.length
                                        ? singleAdData?.excludedOutlets.map(o => o?.name?.toLowerCase().trim()).join(', ')
                                        : "No outlets excluded."}
                                </span></h6>
                            </div>
                            {singleAdData?.product && (
                                <div className="mt-3">
                                    <Table bordered>
                                        <thead>
                                            <tr><th className="text-center" colSpan={6}>PRODUCT INFORMATION</th></tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th className="text-center">IMAGE</th>
                                                <th className="text-center">NAME</th>
                                                <th className="text-center">DESCRIPTION</th>
                                                <th className="text-center">HSN</th>
                                                <th className="text-center">MRP</th>
                                                <th className="text-center">OFFER PRICE</th>
                                            </tr>
                                            <tr>
                                                <td className="text-center"><img src={singleAdData?.product?.displayImage} alt="product" style={{ width: 80, height: 80 }} /></td>
                                                <td className="text-center">{singleAdData?.product?.name}</td>
                                                <td className="text-center">{singleAdData?.product?.description}</td>
                                                <td className="text-center">{singleAdData?.product?.hsn}</td>
                                                <td className="text-center">{singleAdData?.product?.mrp}</td>
                                                <td className="text-center">{singleAdData?.product?.offerPrice} Rs</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="warning" onClick={() => setOpenViewModal(false)} style={{ borderRadius: 18 }}>CLOSE</Button>
                        </Modal.Footer>
                    </Modal>
                )}

                {/* ---------------- Delete Modal ---------------- */}
                {openDeleteModal && (
                    <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered>
                        <Modal.Header closeButton><Modal.Title>Confirm Delete</Modal.Title></Modal.Header>
                        <Modal.Body>Are you sure you want to delete this advertisement? This action cannot be undone.</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>Cancel</Button>
                            <Button variant="danger" onClick={deleteAdvertisement}>
                                {isDeleteBtnLoading ? <Spinner as="span" animation="border" size="sm" /> : "Delete Advertisement"}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

                {/* ---------------- Update Image Modal ---------------- */}
                {isOpenUpdateImageModal && (
                    <Modal show={isOpenUpdateImageModal} onHide={() => setIsOpenUpdateImageModal(false)} centered>
                        <Modal.Header closeButton><Modal.Title className="fs-6">UPDATE ADVERTISEMENT IMAGE</Modal.Title></Modal.Header>
                        <Form>
                            <Modal.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-semibold">Choose File <span className="text-danger">*</span></Form.Label>
                                    <Form.Control type="file" onChange={handleEditImageChange} id="imageInput" />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" onClick={handleEditImage} disabled={isImageUpdating}>
                                    {isImageUpdating ? <Spinner size='sm' /> : 'SAVE CHANGES'}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                )}
            </div>

            <style>{`
                @keyframes skeletonPulse { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
                .table > :not(caption) > * > * { padding-top: 12px; padding-bottom: 12px; }
            `}</style>
        </React.Fragment>
    );
};

export default AdvertisementMgt;